export default class Panel extends Phaser.GameObjects.Container {
    // Init
    constructor(scene, width, height,number) {
        super(scene, 0, 0);
        this.rect = new Phaser.Geom.Rectangle(0, 0, width, height);
        //this.setSize(width,height);
        //this.w = width
        //this.h = height
        this.number = number || 1
        scene.add.existing(this);
        this.parent = scene
        this.init()
        this.index = 0;
        this.emptyPanel()
        //scene.input.setDraggable(this);
    }
    //パネルを画像化した
    init() {
        var progressBox = new Phaser.GameObjects.Graphics(this.parent);
        progressBox.fillStyle(0xFF0000, 0.5);
        //progressBox.fillRect(0, 0, this.rect.width, this.rect.height);
        progressBox.fillRectShape(this.rect);
        
        //選択時のオレンジ
        var cleamenu1  =  new Phaser.GameObjects.Sprite(this.parent,this.rect.width/2, this.rect.height/2);
        cleamenu1.setTexture('img_pnum');
        cleamenu1.setDisplaySize(this.rect.width, this.rect.height);
        this.add(cleamenu1);
        this.rectgr = cleamenu1
        this.rectgr.setVisible(false)
　　　　　//３層目の黒 数字が消えた際表示される

        cleamenu1  =  new Phaser.GameObjects.Sprite(this.parent,this.rect.width/2, this.rect.height/2);
        cleamenu1.setTexture('img_pnum');
        cleamenu1.setDisplaySize(this.rect.width, this.rect.height);

        this.add(cleamenu1);
        this.rectgr2 = cleamenu1
        this.rectgr2.setVisible(false)
        　//4層目のヘルプ

        cleamenu1  =  new Phaser.GameObjects.Sprite(this.parent,this.rect.width/2, this.rect.height/2);
        cleamenu1.setTexture('img_pnum');
        cleamenu1.setDisplaySize(this.rect.width, this.rect.height);

        this.add(cleamenu1);
        this.rectgr3 = cleamenu1
        this.rectgr3.setVisible(false)
        //5層目の数字
        //var cleamenu2  =  new Phaser.GameObjects.Text(this.parent,35,30,'0',{ fill: '#fff',fontSize:'48px' });
        cleamenu1  =  new Phaser.GameObjects.Sprite(this.parent,this.rect.width/2, this.rect.height/2);
        cleamenu1.setTexture('img_pnum');
        cleamenu1.setDisplaySize(this.rect.width, this.rect.height);

        
        this.add(cleamenu1);
        this.num = cleamenu1;
        this.setNumber(this.number)
        this.setDepth(1000);
       
    }
    //数字を画像化する前の初期化
    /*
    init_old() {
        //最深部　黒
        
        var progressBox = new Phaser.GameObjects.Graphics(this.parent);
        progressBox.fillStyle(0x000000, 0.5);
        //progressBox.fillRect(0, 0, this.rect.width, this.rect.height);
        progressBox.fillRectShape(this.rect);

        this.add(progressBox);
        //選択時のオレンジ
        var progressBox2 = new Phaser.GameObjects.Graphics(this.parent);
        progressBox2.fillStyle(0xfd7e00, 0.5);
        //progressBox.fillRect(0, 0, this.rect.width, this.rect.height);
        progressBox2.fillRectShape(this.rect);

        this.add(progressBox2);
        this.rectgr = progressBox2
        this.rectgr.setVisible(false)
　　　　　//３層目の黒 数字が消えた際表示される
        var progressBox3 = new Phaser.GameObjects.Graphics(this.parent);
        progressBox3.fillStyle(0x000000, 0.8);
        //progressBox.fillRect(0, 0, this.rect.width, this.rect.height);
        progressBox3.fillRectShape(this.rect);

        this.add(progressBox3);
        this.rectgr2 = progressBox3
        this.rectgr2.setVisible(false)
        //4層目の数字
        var cleamenu2  =  new Phaser.GameObjects.Text(this.parent,35,30,'0',{ fill: '#fff',fontSize:'48px' });
        
        this.add(cleamenu2);
        this.num = cleamenu2;
        this.setNumber(this.number)
        this.setDepth(1000);

    }*/
    setNumber(num){
       /*  this.number = num
        this.num.setText(num) */
        this.number = num
        if(num>0){
         this.num.setFrame(num - 1) //通常時
         this.rectgr.setFrame(num - 1 + 9) //選択時
         this.rectgr2.setFrame(num - 1 + 18)//削除時
         this.rectgr3.setFrame(num - 1 + 27)//ヘルプ時
         this.num.setVisible(true)
         this.rectgr.setVisible(false)
         this.rectgr2.setVisible(false)
         this.rectgr3.setVisible(false)
        //this.num.setText(num)
        }
    }
    setPosition(x,y){
        if(this.rect){
            this.rect.setPosition(x,y)
        }
        super.setPosition(x,y)
    }
     // getter
    get select() {
        return this.rectgr.visible
    }

    // setter
    set select(value) {
      if(this.rectgr2.visible){
        this.num.setVisible(false)
        this.rectgr.setVisible(false)
        this.rectgr2.setVisible(true)
        this.rectgr3.setVisible(false)
      }else{
    　 this.num.setVisible(!value)
       this.rectgr3.setVisible(!value)
       this.rectgr.setVisible(value)
      }
    }
       // getter
    get avail() {
        return !this.rectgr2.visible
    }

    // setter
    set avail(value) {
       this.num.setVisible(value)
       this.rectgr.setVisible(value)
       this.rectgr2.setVisible(!value)
       this.rectgr3.setVisible(value)
    }
    emptyPanel(){
        this.num.setVisible(false)
        this.rectgr.setVisible(false)
        this.rectgr2.setVisible(false)
        this.rectgr3.setVisible(false)
    }
}